import React from 'react'
import { injectIntl } from 'react-intl'
import { Button, Form, Input, Modal } from 'antd'

const ConfirmPassword = ({ visible, onSubmit, onCancel, loading, intl: { formatMessage } }) => {
  const [form] = Form.useForm()

  return (
    <Modal
      title={formatMessage({ id: 'text.Roles' })}
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" hideRequiredMark onFinish={onSubmit}>
        <Form.Item
          name="name"
          label={formatMessage({ id: 'form.label.Role' })}
          rules={[
            { required: true, message: formatMessage({ id: 'form.error.required' }) },
          ]}
        >
          <Input
            size="large"
            placeholder={formatMessage({ id: 'form.placeholder.Role' })}
            maxLength={64}
            style={{ textTransform: 'capitalize' }}
          />
        </Form.Item>
        <Form.Item className="text-right">
          <Button type="primary" htmlType="submit" size="large" loading={loading}>
            {formatMessage({ id: 'action.confirm' })}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default injectIntl(ConfirmPassword)
